<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" small color="primary">info</v-icon>
    </template>
    <span v-if="unitType === 'cpc'">
      1クリックあたりの単価<br />クリック発生時の課金となります
    </span>
    <span v-if="unitType === 'cpm'">
      インプレッション1000 回あたりの単価<br />1インプレッション単位での課金となります
    </span>
    <span v-if="unitType === 'cpcv'">
      再生完了数ごとの課金となります
    </span>
    <span v-if="unitType === 'cost plus margin'">
      オークションでの入札に応じて単価が変動します<br />1インプレッション単位での課金となります
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    unitType: {
      type: String,
      default: 'cpc',
    },
  },
}
</script>

<style scoped></style>
